import { Button, Popconfirm } from 'antd';
import i18next from 'i18next';
import { CREATE_TASK_FORM_ID } from './CreateOrUpdateTask';

export const getHeaderButtonsArray = ({
  isEditPage,
  isCreateLoading,
  onDelete,
  isTaskDeleteLoading,
}: {
  isEditPage: boolean;
  isCreateLoading: boolean;
  onDelete: () => void;
  isTaskDeleteLoading: boolean;
}) => {
  let btns = [
    <Button
      form={CREATE_TASK_FORM_ID}
      key="submit"
      htmlType="submit"
      type="primary"
      loading={isCreateLoading}
    >
      {i18next.t('Task.CreateTask.Save', 'Save')}
    </Button>,
  ];
  if (isEditPage) {
    btns = [
      <Popconfirm
        key="1"
        placement="bottomRight"
        title={i18next.t(
          'Task.EdtiTask.AreYouSureDeleteTask?',
          'Are you sure you want to delete this task?',
        )}
        onConfirm={onDelete}
        onCancel={() => {}}
        okText={i18next.t('Task.EdtiTask.Yes', 'Yes')}
        cancelText={i18next.t('Task.EdtiTask.No', 'No')}
      >
        <Button danger loading={isTaskDeleteLoading}>
          {i18next.t('Task.EdtiTask.Delete', 'Delete')}
        </Button>
      </Popconfirm>,
      ...btns,
    ];
  }
  return btns;
};
